/**
 * @Desc: 饼状图--百分比
 */
<template>
  <div
    class="pieEcharts"
    ref="pieEcharts"
  ></div>
</template>
<script>
import echarts from "echarts";
export default {
  props: {
    options: {
      type: Array
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    // this.chart = echarts.init(this.$refs.pieEcharts);
    // this.drawAxis();
  },
  watch: {
    options: {
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal) {
          this.$nextTick(() => {
            this.chart = echarts.init(this.$refs.pieEcharts);
            this.drawAxis();
          });
        }
        
      }
    },
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
  },
  methods: {
    drawAxis() {
      // 绘制图表
      let self = this;
      let echartsOption = {
        color: ['#05C439', '#CACACA'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          show:false,
        },
        grid: {
          top: "20%",
          left: "10%",
          right: "40%",
          // bottom: "10%",
          containLabel: true
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "85%",
            center: ["50%", "50%"],
            // top: '10%',
            clickable:false,
            hoverOffset: 2,
            selectedOffset: 2,
            hoverAnimation: false,
            silent: true,
            animation : false,
            label: {
              normal: {
                show: false,
                position: "left"
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "16",
                  fontWeight: "bold"
                },
                formatter: "{d}%\n{b}"
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "直接访问", selected: true },
              { value: 310, name: "邮件营销" },
            ]
          }
        ]
      };
     
      echartsOption.series[0].data = this.options;
      this.chart.setOption(echartsOption);
    
    },

  },
  created() {
  }
};
</script>
<style lang="less">
.pieEcharts {
  width: 20px;
  height: 20px;
  display: inline-block;
}
</style>
